import { useFormik } from "formik";
import React, { useEffect } from "react";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import {
    Grid,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Switch,
} from "@mui/material";
import { FormHeading } from "../../Layouts/Heading";
import { useDispatch, useSelector } from "react-redux";
import { adderReset, GetAllAdders } from "../../Redux/AddersSlice/AddersSlice";
import styled from "@emotion/styled";
import { CreateAPC, apcReset } from "../../Redux/APCAdder/ApcAdderSlice";
import { toast } from "react-toastify";

const CreateAPCAdder = () => {
    const dispatch = useDispatch();
    // const { apc, isLoading } = useSelector((state) => state.apc_adders);
    const { isLoading, isSuccess, isError, message } = useSelector(
        (state) => state.apc_adders
    );
    const { adders } = useSelector((state) => state.adders);
    const All_Adders = adders?.data || [];
    const formik = useFormik({
        initialValues: {
            adder_id: "",
            price: "",
            unit: "",
            price_type: "",
            is_adder: "",
            availability: true,
        },
        onSubmit: async (values) => {
            await dispatch(CreateAPC(values));
            await dispatch(apcReset());
        },
    });

    useEffect(() => {
        const GetAllAddersAction = async () => {
            await dispatch(GetAllAdders({ return_all: 1, active:1 }));
            await dispatch(adderReset());
        };
        GetAllAddersAction();
    }, []);

    useEffect(() => {
        if (isSuccess) {
            toast.success("Created successfully");
            formik.values.adder_id = "";
            formik.values.price = "";
            formik.values.unit = "";
            formik.values.price_type = "";
            formik.values.is_adder = "";
            formik.values.availability = true;
        }
    }, [isSuccess]);

    return (
        <>
            <FormHeading> Create APC Adder </FormHeading>
            <FormContainer>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item mb={1} xs={12} md={6}>
                            <FormControl fullWidth required={true}>
                                <InputLabel id="demo-simple-select-label">
                                    Adder
                                </InputLabel>
                                <Select
                                    id="adder_id"
                                    name="adder_id"
                                    label="Adder"
                                    required={true}
                                    value={formik.values.adder_id}
                                    onChange={formik.handleChange}
                                >
                                    {All_Adders?.map((key) => (
                                        <MenuItem key={key.id} value={key.id}>
                                            {key.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6}>
                            <TextField
                                fullWidth
                                id="price"
                                name="price"
                                label="Price"
                                type="text"
                                values={formik.values.price}
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item mb={1} xs={12} md={6}>
                            <FormControl fullWidth required={true}>
                                <InputLabel id="demo-simple-select-label">
                                    Is Adder
                                </InputLabel>
                                <Select
                                    id="is_adder"
                                    name="is_adder"
                                    label="Is Adder"
                                    required={true}
                                    value={formik.values.is_adder}
                                    onChange={formik.handleChange}
                                >
                                    <MenuItem value="adder">Adder</MenuItem>
                                    <MenuItem value="no adder">
                                        No Adder
                                    </MenuItem>
                                    <MenuItem value="no can do">
                                        No Can Do
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6}>
                            <FormControl fullWidth required={true}>
                                <InputLabel id="demo-simple-select-label">
                                    Price Type
                                </InputLabel>
                                <Select
                                    id="price_type"
                                    name="price_type"
                                    label="Price Type"
                                    required={true}
                                    value={formik.values.price_type}
                                    onChange={formik.handleChange}
                                >
                                    <MenuItem value="labor and material">
                                        Labor And Material
                                    </MenuItem>
                                    <MenuItem value="labor only">
                                        Labor Only
                                    </MenuItem>
                                    <MenuItem value="material only">
                                        Material Only
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6}>
                            <TextField
                                fullWidth
                                id="unit"
                                name="unit"
                                label="Unit"
                                value={formik.values.unit}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched.unit &&
                                    Boolean(formik.errors.unit)
                                }
                                helperText={
                                    formik.touched.unit && formik.errors.unit
                                }
                            />
                        </Grid>

                        <Grid item mb={1} xs={12} md={6}>
                            <InputLabel> Availability </InputLabel>
                            <Switch
                                id="availability"
                                name="availability"
                                checked={formik.values.availability}
                                onChange={formik.handleChange}
                                inputProps={{ "aria-label": "controlled" }}
                            />
                        </Grid>
                    </Grid>

                    <PrimaryButton fullWidth type="submit">
                        {isLoading ? "loading..." : "Create"}
                    </PrimaryButton>
                </form>
            </FormContainer>
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default CreateAPCAdder;
